import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import iconDelete from '../../../../assets/images/icon_delete_custom.svg';

export default function CustomItensRequestList(props) {
  const [dropDownOpen, setDropDownOpen] = useState(false);

  const { i18n } = useTranslation();

  const toggleMethodDropdown = () => {
    setDropDownOpen(!dropDownOpen);
  };

  const updateValueType = (type) => {
    toggleMethodDropdown();

    props.changeValue(props.index, type);
  };

  const labels = {
    id: 'Id',
    status: 'Status',
    subject: 'Assunto',
    description: 'Descrição',
  };

  return (
    <div className="header-added-value">
      <div className="common-form-group">
        <label>{i18n.t('Chave')}</label>
        <input
          type="text"
          id="row-key"
          name="rowKey"
          className="form-control col-md-11 mt-1"
          value={props.row.key}
          onChange={(e) => props.changeKey(props.index, e)}
        />
      </div>

      {/* REQUEST PARAMS */}
      <div
        className="common-form-group validation-input-group destination-input-group mb-1"
        hidden={props.answerHandlerOpen}
      >
        <label>{i18n.t('Valor')}</label>
        <input
          type="text"
          disabled
          className="form-control outline-none input-control mt-1"
          value={labels[`${props.item.value}`] || ''}
        />
        <i className="arrow down" />
        <button type="button" onClick={toggleMethodDropdown} />
        <div className="validation-dropdown" hidden={!dropDownOpen}>
          {/* ID */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateValueType('id')}
          >
            <span>Id</span>
            <i className="arrow down" hidden={props.item.value !== 'id'} />
          </div>
          {/* STATUS */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateValueType('status')}
          >
            <span>Status</span>
            <i className="arrow down" hidden={props.item.value !== 'status'} />
          </div>
          {/* SUBJECT */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateValueType('subject')}
          >
            <span>Assunto</span>
            <i className="arrow down" hidden={props.item.value !== 'subject'} />
          </div>
          {/* DESCRIPTION */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateValueType('description')}
          >
            <span>Descrição</span>
            <i
              className="arrow down"
              hidden={props.item.value !== 'description'}
            />
          </div>
        </div>
      </div>
      <img
        src={iconDelete}
        alt=""
        className="img-header-custom"
        onClick={() => props.deleteKeyValue(props.row)}
      />
    </div>
  );
}
